<template>
    <IndexHeader />
    <div v-if="currentStep === 1">
        <OrderCheck @paymentStep="updateStep" />
    </div>
    <div v-if="currentStep === 2">
        <OrderPay @paymentStep="updateStep" />
    </div>
    <HomePageFooter />
</template>

<script>
// 首页顶部导航栏
import IndexHeader from "../components/IndexHeader/TopBar";
// 订单确认
import OrderCheck from "../components/Payment/OrderCheck"
// 订单支付
import OrderPay from "../components/Payment/OrderPay"
// 首页底部Footer
import HomePageFooter from "../components/HomePageFooter/Footer";

export default {
    data() {
        return {
            currentStep: 1,
            routePara: '',
        }
    },
    created() {
        console.log('step1',this.$route.query);
        this.routePara = parseInt(this.$route.query.step);
        console.log('routePara',typeof this.routePara);
        if(this.routePara > 0 ) {
            this.currentStep = this.routePara
        }
    },
    components: {
        IndexHeader,
        OrderCheck,
        OrderPay,
        HomePageFooter,
    },
    methods: {
        updateStep(stepIndex) {
            if(this.routePara){
                this.currentStep = routePara
            }else{
                this.currentStep = stepIndex;
            }
            
        }
    },
}
</script>